import { __generator } from "tslib";
import { all, put, call, select, takeEvery, takeLatest, } from 'redux-saga/effects';
import { initMediaPopup, initBrowseStream, initGallectionDeviationStream, initGallectionStream, initCustomSetDeviationStream, fetchMoreGallections, fetchMoreBrowseDeviations, fetchMoreGallectionDeviations, changeCurrentMediaSource, setSearchQuery, setCurrentFolderId, unsetCurrentFolderId, deselectAll, addDeviations, copyDeviations, moveDeviations, removeDeviations, removeGallection, makeDeviationCurrentGallectionCover, moveGallectionToPosition, moveGallection, moveDeviationToPosition, setGallectionName, setGallectionDescription, setGallectionPrice, createGallection, onSelectableItemClick, replaceSelect, toggleAppendSelect, uploadFile, setCurrentSubfolderId, unsetCurrentSubfolderId, } from '../actions';
import { getSelectionLimit } from '../selectors';
import { selectors, withOffset } from '../../Stream';
import { MEDIA_POPUP_BROWSE_DEVIATION_STREAM_ID, MEDIA_POPUP_BROWSE_SEARCH_DEVIATION_STREAM_ID, MEDIA_POPUP_GALLECTION_DEVIATION_STREAM_GROUP, MEDIA_POPUP_GALLECTION_STREAM_GROUP, } from '../constants';
import initGallectionStreamHandler from './initGallectionStream';
import initBrowseStreamHandler from './initBrowseStream';
import initGallectionDeviationStreamHandler from './initGallectionDeviationStream';
import initCustomSetDeviationStreamHandler from './initCustomSetDeviationStream';
import gallectionDeviationStreamFetch from './gallectionDeviationStreamFetch';
import browseDeviationStreamFetch from './browseDeviationStreamFetch';
import gallectionStreamFetchHandler from './gallectionStreamFetch';
import copyDeviationsHandler from './copyDeviations';
import moveDeviationsHandler from './moveDeviations';
import removeDeviationsHandler from './removeDeviations';
import addDeviationsHandler from './addDeviations';
import removeGallectionHandler from './removeGallection';
import initMediaPopupHandler from './initMediaPopup';
import changeCurrentMediaSourceHandler from './changeCurrentMediaSource';
import setSearchQueryHandler from './setSearchQuery';
import fetchMoreGallectionsHandler from './fetchMoreGallections';
import fetchMoreGallectionDeviationsHandler from './fetchMoreGallectionDeviations';
import fetchMoreBrowseDeviationsHandler from './fetchMoreBrowseDeviations';
import createGallectionHandler from './createGallection';
import setGallectionNameHandler from './setGallectionName';
import setGallectionPriceHandler from './setGallectionPrice';
import saveChangedGallectionNameHandler from './saveChangedGallectionName';
import saveChangedGallectionPriceHandler from './saveChangedGallectionPrice';
import setGallectionDescriptionHandler from './setGallectionDescription';
import saveChangedGallectionDescriptionHandler from './saveChangedGallectionDescription';
import makeDeviationGallectionCoverHandler from './makeDeviationGallectionCover';
import moveGallectionToPositionHandler from './moveGallectionToPosition';
import moveGallectionHandler from './moveGallection';
import moveDeviationToPositionHandler from './moveDeviationToPosition';
import uploadFileHandler from './uploadFile';
function streamFetchHandler(action) {
    var streamId, _a, groupId, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                streamId = action.streamId;
                _a = streamId;
                switch (_a) {
                    case MEDIA_POPUP_BROWSE_DEVIATION_STREAM_ID: return [3 /*break*/, 1];
                    case MEDIA_POPUP_BROWSE_SEARCH_DEVIATION_STREAM_ID: return [3 /*break*/, 1];
                }
                return [3 /*break*/, 3];
            case 1: return [4 /*yield*/, call(browseDeviationStreamFetch, action)];
            case 2: return [2 /*return*/, _c.sent()];
            case 3: return [4 /*yield*/, select(selectors.getGroupId, streamId)];
            case 4:
                groupId = _c.sent();
                _b = groupId;
                switch (_b) {
                    case MEDIA_POPUP_GALLECTION_STREAM_GROUP: return [3 /*break*/, 5];
                    case MEDIA_POPUP_GALLECTION_DEVIATION_STREAM_GROUP: return [3 /*break*/, 7];
                }
                return [3 /*break*/, 9];
            case 5: return [4 /*yield*/, call(gallectionStreamFetchHandler, action)];
            case 6: return [2 /*return*/, _c.sent()];
            case 7: return [4 /*yield*/, call(gallectionDeviationStreamFetch, action)];
            case 8: return [2 /*return*/, _c.sent()];
            case 9: return [2 /*return*/];
        }
    });
}
export default function saga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, all([
                    takeEvery(initMediaPopup, initMediaPopupHandler),
                    takeEvery(initBrowseStream, initBrowseStreamHandler),
                    takeEvery(initGallectionStream, initGallectionStreamHandler),
                    takeEvery(initCustomSetDeviationStream, initCustomSetDeviationStreamHandler),
                    takeEvery(fetchMoreGallections, fetchMoreGallectionsHandler),
                    takeEvery(fetchMoreBrowseDeviations, fetchMoreBrowseDeviationsHandler),
                    takeEvery(fetchMoreGallectionDeviations, fetchMoreGallectionDeviationsHandler),
                    takeEvery(addDeviations, addDeviationsHandler),
                    takeEvery(copyDeviations, copyDeviationsHandler),
                    takeEvery(moveDeviations, moveDeviationsHandler),
                    takeEvery(removeDeviations, removeDeviationsHandler),
                    takeEvery(createGallection, createGallectionHandler),
                    takeEvery(removeGallection, removeGallectionHandler),
                    takeEvery(setGallectionName, setGallectionNameHandler),
                    takeLatest(setGallectionName, saveChangedGallectionNameHandler),
                    takeEvery(setGallectionDescription, setGallectionDescriptionHandler),
                    takeLatest(setGallectionDescription, saveChangedGallectionDescriptionHandler),
                    takeEvery(setGallectionPrice, setGallectionPriceHandler),
                    takeLatest(setGallectionPrice, saveChangedGallectionPriceHandler),
                    takeEvery(moveGallection, moveGallectionHandler),
                    takeEvery(moveGallectionToPosition, moveGallectionToPositionHandler),
                    takeEvery(moveDeviationToPosition, moveDeviationToPositionHandler),
                    takeEvery(makeDeviationCurrentGallectionCover, makeDeviationGallectionCoverHandler),
                    takeEvery(initGallectionDeviationStream, initGallectionDeviationStreamHandler),
                    takeEvery(withOffset.actions.STREAM__WITH_OFFSET__FETCH, streamFetchHandler),
                    takeEvery(changeCurrentMediaSource, changeCurrentMediaSourceHandler),
                    takeEvery(setSearchQuery, setSearchQueryHandler),
                    takeEvery(setCurrentFolderId, function () {
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, all([
                                        put(unsetCurrentSubfolderId()),
                                        put(initGallectionDeviationStream()),
                                    ])];
                                case 1:
                                    _a.sent();
                                    return [2 /*return*/];
                            }
                        });
                    }),
                    takeEvery(setCurrentSubfolderId, function () {
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, put(initGallectionDeviationStream())];
                                case 1:
                                    _a.sent();
                                    return [2 /*return*/];
                            }
                        });
                    }),
                    takeEvery([
                        unsetCurrentFolderId,
                        unsetCurrentSubfolderId,
                        setCurrentFolderId,
                        setCurrentSubfolderId,
                    ], function () {
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, put(deselectAll())];
                                case 1:
                                    _a.sent();
                                    return [2 /*return*/];
                            }
                        });
                    }),
                    takeEvery(onSelectableItemClick, function (action) {
                        var selectionLimit;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, select(getSelectionLimit)];
                                case 1:
                                    selectionLimit = _a.sent();
                                    if (!(selectionLimit === 1)) return [3 /*break*/, 3];
                                    return [4 /*yield*/, put(replaceSelect(action.payload))];
                                case 2:
                                    _a.sent();
                                    return [3 /*break*/, 5];
                                case 3: return [4 /*yield*/, put(toggleAppendSelect(action.payload))];
                                case 4:
                                    _a.sent();
                                    _a.label = 5;
                                case 5: return [2 /*return*/];
                            }
                        });
                    }),
                    takeEvery(uploadFile, uploadFileHandler),
                ])];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
//# sourceMappingURL=index.js.map